import { Injectable } from '@angular/core';

const lightTheme = {
    background: '#FAFAFA',
    paper: '#FFFFFF',
    contrast: '#000000',
    textContrast: '#000000',
    primary: '#3E8BC7',
    secondary: '#F59331',
    warn: '#E71717',
    divider: 'rgba(0, 0, 0, 0.12)'
};

const darkTheme = {
    background: '#121212',
    paper: '#363636',
    contrast: '#FFFFFF',
    textContrast: '#FFFFFF',
    primary: '#359AEA',
    secondary: '#F59331',
    warn: '#F44336',
    divider: 'rgba(255, 255, 255, 0.12)'
};

@Injectable({
    providedIn: 'root'
})

export class ThemeService {
    // darkTheme: boolean = localStorage.getItem('dark-mode')
    //     ? JSON.parse(localStorage.getItem('dark-mode'))
    //     : window.matchMedia('(prefers-color-scheme: dark)').matches;

    darkTheme = true;

    // Default theme values is dark
    themeValues = darkTheme;

    startTheme(): void {
        this.setTheme(this.darkTheme);
    }

    toggleTheme(): void {
        this.darkTheme = !this.darkTheme;
        localStorage.setItem('dark-mode', JSON.stringify(this.darkTheme));
        this.setTheme(this.darkTheme);
    }

    setDarkTheme(isDarkTheme: boolean): void {
        this.darkTheme = isDarkTheme;
        localStorage.setItem('dark-mode', JSON.stringify(isDarkTheme));
        this.setTheme(isDarkTheme);
    }

    private setTheme(isDarkTheme: boolean): void {
        if (isDarkTheme) {
            document.documentElement.setAttribute('data-color-scheme', 'dark');
            document.body.className = 'dark-theme';
            this.themeValues = darkTheme;
        } else {
            document.documentElement.setAttribute('data-color-scheme', 'light');
            document.body.className = '';
            this.themeValues = lightTheme;
        }
    }

}
